import classNames from 'classnames';
import React from 'react';
import styles from './Popover.module.scss';

export const OPEN_CLASS_NAME = 'PopoverTarget_openClass';

interface Props {
  target: React.ReactElement;
  isCurrentlyOpen: boolean;
  targetCaret: boolean;
  ignoreTargetOnClick: boolean;
  onClick: (event: React.MouseEvent) => void;
  onFocus: null | ((event: React.FocusEvent) => void);
  targetWrapperElement: string;
  targetWrapper: boolean;
}

export const PopoverTarget = React.forwardRef((props: Props, ref) => {
  const {
    target,
    isCurrentlyOpen,
    targetCaret,
    ignoreTargetOnClick,
    onClick,
    onFocus = null,
    targetWrapperElement,
    targetWrapper,
  } = props;

  // Not all popovers require a target
  if (!target) {
    return null;
  }

  const targetProps = {
    ...target.props,
    onFocus,
    onClick: (...args: Array<any>) => {
      // Avoid propagating clicks on target, let Popover figure it out
      // NB: Removing this breaks Popover within Popover,
      // like PopoverDropdownList with a confirm option
      // @ts-expect-error does this even work?????
      if (args.event && typeof args.event === typeof MouseEvent) {
        // @ts-expect-error does this even work?????
        args.event.stopPropagation();
      }

      /** Hello Furture Self or Coworker
       * when the following code arrived it came commented like it is
       * I didn't want to break anything so I left it.
       * Do we need both? I dont' know, but here we are.
       * Feel free to do your thing. You know best.
       */

      // This is maybe a (better?) solution to ^^?
      if (!ignoreTargetOnClick) {
        target.props.onClick?.(...args);
      }

      // @ts-expect-error
      onClick(...args);
    },
    className: classNames(target.props.className, { [OPEN_CLASS_NAME]: isCurrentlyOpen }),
  };

  const targetName =
    typeof target.type === 'string'
      ? target.type
      : ((target.type as any).displayName ?? target.type.name);
  if ((targetName ?? '').endsWith('Button')) {
    targetProps.isActive = isCurrentlyOpen;
    if (targetProps.caret !== false) {
      targetProps.caret = targetCaret;
    }
  }

  // Wrap the target in whatever element specified
  if (targetWrapper) {
    return React.createElement(
      targetWrapperElement,
      { className: styles.targetWrapper, ref },
      React.cloneElement(target, targetProps)
    );
  }

  targetProps.ref = ref;
  return React.cloneElement(target, targetProps);
});

PopoverTarget.displayName = 'PopoverTarget';
